// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"115676c4","30":"7d01b8ee","49":"aa7f3467","108":"70d7fc5c","210":"9c310928","311":"9bc2a147","321":"887c8212","449":"45b92d71","720":"cec9c838","733":"a2e39251","919":"a3ccfba8"}[chunkId] + ".chunk.js";
};